import type { ADFEntity } from '@atlaskit/adf-utils/types';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import { cfetch } from '@confluence/network';

export const ISSUEKEY_REGEX = '([A-Z][A-Z0-9_]+-\\d+)';

export const doesIssueExist = (issueKey: string) => {
	return cfetch(`/rest/api/3/issue/${issueKey}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
		},
		credentials: 'include',
	});
};

export const buildSmartLinkIssueKeyAutoFormatter = () => {
	if (editorExperiment('platform_editor_ai_1p_smart_link_unfurl_in_prompt', true)) {
		return Promise.resolve({
			getRules: async () => ({
				[ISSUEKEY_REGEX]: (match: string[]): Promise<ADFEntity | null> => {
					const issueKey = match[1];
					return doesIssueExist(issueKey)
						.then((issueExists) => {
							if (issueExists) {
								if (
									editorExperiment('platform_editor_ai_1p_smart_link_unfurl_in_prompt', true, {
										exposure: true,
									})
								) {
									const url = `${window.location.protocol}//${window.location.host}/browse/${issueKey}`;
									return {
										type: 'inlineCard',
										attrs: { url },
									};
								}
							}
							return null;
						})
						.catch(() => null);
				},
			}),
		});
	}
	return undefined;
};
